<template>
  <ais-current-refinements class="products-listing-applied-filters">
    <template v-slot="{ items, createURL }">
      <div v-if="removableRefinements(items).length > 0"
           class="products-listing-applied-filters__main">
        <div class="products-listing-applied-filters__filters">
          <template v-for="filter in removableRefinements(items)">
            <div v-for="refinement in filter.refinements"
                 :key="getRefinementKey(refinement)"
                 class="products-listing-applied-filters__filter">
              {{ getRefinementLabel(filter, refinement) }}
              <a v-if="canFilterRefinementBeRemoved(refinement)"
                 :href="createURL(refinement)"
                 @click.prevent="filter.refine(refinement)">
                <i class="fas fa-times" />
              </a>
            </div>
          </template>
        </div>

        <div class="products-listing-applied-filters__buttons-container">
          <ais-clear-refinements class="products-listing-applied-filters__clear-btn">
            <template v-slot="{ canRefine, refine, createURL }">
              <a v-if="canRefine && removableRefinements(items)"
                 :href="createURL()"
                 @click.prevent="refine">
                Clear Filters
              </a>
              <div v-else/>
            </template>
          </ais-clear-refinements>
        </div>
      </div>

      <div v-else/>
    </template>
  </ais-current-refinements>
</template>

<script>
import { compact } from 'lodash'
import { AisCurrentRefinements, AisClearRefinements } from 'vue-instantsearch'
import ProductsListingRemovableRefinementsMixin from '@/mixins/products/listing/productsListingRemovableRefinements'

export default {
  name: 'ProductsListingAppliedFilters',
  mixins: [
    ProductsListingRemovableRefinementsMixin
  ],
  components: {
    AisCurrentRefinements,
    AisClearRefinements
  },
  props: {
    category: {
      type: Object,
      default: null
    },
    categories: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    isCategoryPage() {
      return !!this.category
    }
  },
  methods: {
    getRefinementKey (refinement) {
      return [
        refinement.attribute,
        refinement.type,
        refinement.value,
        refinement.operator
      ].join(':')
    },
    getRefinementLabel (filter, refinement) {
      if (/^true|false$/i.test(refinement.label)) {
        const newValue = /^true$/i.test(refinement.label) ? 'Yes' : 'No'

        return `${this.getMainFilterName(filter.label)}: ${newValue}`
      }

      if (/^category\.lvl\d/i.test(refinement.attribute)) {
        let subCategories = refinement.label.split(' > ')
            subCategories = subCategories.map((_e, i) => subCategories.slice(0, i + 1).join('/'))
        let categories = subCategories.map(sub => this.categories.find(({ permalink }) => permalink === sub))
            categories = compact(categories)

        if (subCategories.length > categories.length) {
          return this.getMainFilterName(refinement.value)
        }

        return this.getMainFilterName(categories.map(e => e.name).join(' > '))
      }

      return refinement.label.replace(/-and-/gi, ' & ')
    },
    getMainFilterName (value) {
      return value
        .replace(/^properties\.filter_/, '')
        .replace('supplier.name', 'brand')
        .replace('on_sale', 'sale')
        .replace(/\.lvl\d+/, '')
        .replace(/_/g, ' ')
    }
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/stylesheets/variables';

  .products-listing-applied-filters {
    font-family: 'MotivaSans Light';
    font-size: 1.3rem;

    &__main,
    &__filter,
    &__filters {
      display: flex;
      align-items: center;
      column-gap: 10px;
    }

    &__main {
      column-gap: 20px;
    }

    &__filter {
      background: $color-olive-green;
      color: $color-white;
      border-radius: 20px;
      text-transform: capitalize;
      padding: 4px 10px;
    }

    &__clear-btn {
      color: $dark-chestnut-brown;
      font-size: 1.2rem;
      text-decoration: underline;
    }
  }
</style>